"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTodoListElementState = exports.useTodoListElement = void 0;
var _plateCommon = require("@udecode/plate-common");
var _slateReact = require("slate-react");
/* copied from platejs source */

var useTodoListElementState = function useTodoListElementState(_ref) {
  var element = _ref.element;
  var editor = (0, _plateCommon.useEditorRef)();
  var checked = element.checked;
  var readOnly = (0, _slateReact.useReadOnly)();
  return {
    checked: checked,
    editor: editor,
    element: element,
    readOnly: readOnly
  };
};
exports.useTodoListElementState = useTodoListElementState;
var useTodoListElement = function useTodoListElement(state) {
  var checked = state.checked,
    element = state.element,
    readOnly = state.readOnly;
  var editor = (0, _plateCommon.useEditorRef)();
  return {
    checkboxProps: {
      checked: !!checked,
      onCheckedChange: function onCheckedChange(value) {
        if (readOnly) return;
        var path = (0, _plateCommon.findNodePath)(editor, element);
        if (!path) return;
        (0, _plateCommon.setNodes)(editor, {
          checked: value
        }, {
          at: path
        });
      }
    }
  };
};
exports.useTodoListElement = useTodoListElement;